<template>
    <div class="serviceList">
        <div class="serviceBox" v-for="(item,index) in serviceList" :key="item.id" @click="serviceTap(item.id)">
            <el-image :src="item.goods_img" fit="cover" lazy class="serviceImg"></el-image>
            <div class="serviceTitle">{{ item.goods_name }}</div>
            <div class="serviceSpb">
                <div class="servicePrice"><span>￥</span>{{ item.sale_price }}</div>
                <div class="serviceNum">{{ item.sales }}人已用</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                
            }
        },
        props:{
			serviceList: {
				type: Array,
				default: () => []
			},
		},
        methods: {
            // 跳转服务详情
            serviceTap(e){
                this.$router.push({ path:'/service/detail', query:{id:e} })
            },
        }
    }
</script>
<style lang="less" scoped>
    .serviceList{
        width: 1164px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 4px;
        overflow-y: scroll;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
        .serviceBox{
            width: 280px;
            height: 368px;
            background: #FEFEFE;
            border: 1px solid #FDE4D4;
            border-radius: 8px;
            overflow: hidden;
            margin: 20px 12px 0 0;
            cursor: pointer;
            &:nth-child(4n){
                margin-right: 0;
            }
            .serviceImg{
                width: 280px;
                height: 280px;
            }
            .serviceTitle{
                padding: 16px 18px;
                font: 16px/16px "Microsoft YaHei";
                color: #3E3E3E;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .serviceSpb{
                padding: 8px 15px 0 18px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .servicePrice{
                    font: 18px/18px "Microsoft YaHei";
                    color: #FF6A00;
                    span{
                        font: 12px/18px "Microsoft YaHei";
                    }
                }
                .serviceNum{
                    font: 12px/12px "Microsoft YaHei";
                    color: #A4A4A4;
                }
            }
        }
    }
</style>